module.exports = __webpack_public_path__ + "static/climate_sec2_obj2@2x-67da09f559bcd4eb074d2588ab1a8a5e.png";